/**
 * Danish (da-DK) localization messages for Kendo UI components.
 * Covers grid filters, pager, sort, column menu, date/time inputs and numeric inputs.
 */
const kendoDaDK: Record<string, string> = {
    // Pager (kendo-vue-data-tools - pager.* namespace)
    'pager.info': '{0} - {1} af {2} elementer',
    'pager.firstPage': 'Første side',
    'pager.previousPage': 'Forrige side',
    'pager.nextPage': 'Næste side',
    'pager.lastPage': 'Sidste side',
    'pager.page': 'Side',
    'pager.of': 'af',
    'pager.itemsPerPage': 'elementer pr. side',
    'pager.pageSelection': 'Vælg side',
    'pager.pageInputAriaLabel': 'Sidenummer',
    'pager.smallPageSelectorAriaLabel': 'Vælg side',
    'pager.totalPages': '{0}',

    // Grid - filter operators (text)
    'grid.filterEqOperator': 'Er lig med',
    'grid.filterNotEqOperator': 'Er ikke lig med',
    'grid.filterIsNullOperator': 'Er null',
    'grid.filterIsNotNullOperator': 'Er ikke null',
    'grid.filterIsEmptyOperator': 'Er tom',
    'grid.filterIsNotEmptyOperator': 'Er ikke tom',
    'grid.filterStartsWithOperator': 'Begynder med',
    'grid.filterContainsOperator': 'Indeholder',
    'grid.filterNotContainsOperator': 'Indeholder ikke',
    'grid.filterEndsWithOperator': 'Slutter med',
    'grid.filterGteOperator': 'Er større end eller lig med',
    'grid.filterGtOperator': 'Er større end',
    'grid.filterLteOperator': 'Er mindre end eller lig med',
    'grid.filterLtOperator': 'Er mindre end',

    // Grid - filter operators (date)
    'grid.filterAfterOrEqualOperator': 'Er efter eller lig med',
    'grid.filterAfterOperator': 'Er efter',
    'grid.filterBeforeOperator': 'Er før',
    'grid.filterBeforeOrEqualOperator': 'Er før eller lig med',

    // Grid - filter operators (boolean)
    'grid.filterIsTrue': 'Ja',
    'grid.filterIsFalse': 'Nej',
    'grid.filterBooleanAll': '(Alle)',

    // Grid - filter toolbar / row
    'grid.filterTitle': 'Filter',
    'grid.filterAndLogic': 'Og',
    'grid.filterOrLogic': 'Eller',
    'grid.filterClearButton': 'Ryd',
    'grid.filterSubmitButton': 'Filtrer',
    'grid.filterChooseOperator': 'Vælg operator',

    // Grid - multi-check filter
    'grid.filterCheckAll': 'Vælg alle',
    'grid.filterSelectedItems': 'valgte elementer',
    'grid.filterSearchPlaceholder': 'Søg',

    // Grid - sort
    'grid.sortAscending': 'Sorter stigende',
    'grid.sortDescending': 'Sorter faldende',

    // Grid - column menu
    'grid.columnsApply': 'Anvend',
    'grid.columnsReset': 'Nulstil',

    // Grid - pager
    'grid.pagerFirstPage': 'Første side',
    'grid.pagerPreviousPage': 'Forrige side',
    'grid.pagerNextPage': 'Næste side',
    'grid.pagerLastPage': 'Sidste side',
    'grid.pagerPage': 'Side',
    'grid.pagerOf': 'af',
    'grid.pagerItems': 'elementer',
    'grid.pagerItemsPerPage': 'elementer pr. side',
    'grid.pagerInfo': '{0} - {1} af {2} elementer',

    // Grid - no records
    'grid.noRecords': 'Ingen poster tilgængelige.',

    // DatePicker
    'datepicker.toggleCalendar': 'Skift kalender',

    // DateInput (up/down arrows inside date fields)
    'dateinput.increment': 'Øg værdi',
    'dateinput.decrement': 'Sænk værdi',

    // Calendar
    'calendar.today': 'I dag',
    'calendar.prevView': 'Gå til forrige visning',
    'calendar.nextView': 'Gå til næste visning',

    // NumericTextBox (up/down spin buttons)
    'numerictextbox.increment': 'Øg værdi',
    'numerictextbox.decrement': 'Sænk værdi',

    // TimePicker
    'timepicker.now': 'Nu',
    'timepicker.selectNow': 'Vælg nu',
    'timepicker.cancel': 'Annuller',
    'timepicker.set': 'Sæt',
    'timepicker.toggleTimeSelector': 'Skift tidsvælger',
    'timepicker.toggleClock': 'Skift ur',

    // DateTimePicker
    'datetimepicker.date': 'Dato',
    'datetimepicker.time': 'Tid',
    'datetimepicker.cancel': 'Annuller',
    'datetimepicker.set': 'Sæt',
    'datetimepicker.toggleDateTimeSelector': 'Skift dato-/tidsvælger',

    // DateRangePicker
    'daterangepicker.start': 'Start',
    'daterangepicker.end': 'Slut',
    'daterangepicker.swapStartEnd': 'Byt start og slut',
}

export default kendoDaDK
